/** Desktop messenger panel size preference (contracted vs expanded popout). */

export type MessengerSizeMode = "contracted" | "expanded";

export const MESSENGER_SIZE_STORAGE_KEY = "bb.messenger.sizeMode.v1";

export function parseMessengerSizeMode(raw: string | null | undefined): MessengerSizeMode {
  return raw === "expanded" ? "expanded" : "contracted";
}

export function getMessengerSizeMode(): MessengerSizeMode {
  if (typeof localStorage === "undefined") return "contracted";
  try {
    return parseMessengerSizeMode(localStorage.getItem(MESSENGER_SIZE_STORAGE_KEY));
  } catch {
    return "contracted";
  }
}

export function setMessengerSizeMode(mode: MessengerSizeMode): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(MESSENGER_SIZE_STORAGE_KEY, mode);
  } catch {
    /* ignore quota / private mode */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent<MessengerSizeMode>("bb-messenger-size-changed", { detail: mode })
    );
  }
}

export function subscribeMessengerSizeMode(onChange: (mode: MessengerSizeMode) => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  const onStorage = (e: StorageEvent) => {
    if (e.key !== MESSENGER_SIZE_STORAGE_KEY) return;
    onChange(parseMessengerSizeMode(e.newValue));
  };
  const onCustom = (e: Event) => {
    onChange(parseMessengerSizeMode(String((e as CustomEvent<MessengerSizeMode>).detail)));
  };
  window.addEventListener("storage", onStorage);
  window.addEventListener("bb-messenger-size-changed", onCustom);
  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("bb-messenger-size-changed", onCustom);
  };
}
